module.exports = __webpack_public_path__ + "static/media/icon-red.f165fa85.svg";